class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.toggleButton = this.querySelector('[data-modal-toggle]');
    this.modalContent = this.querySelector('[data-modal-content]');
    this.closeButton = this.querySelector('[data-modal-close]');
    this.overlay = this.querySelector('[data-modal-overlay]');

    if (this.detailsContainer && this.summaryToggle) {
      this.isLegacy = true;
      this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

      this.summaryToggle.setAttribute('role', 'button');
      return;
    }

    if (!this.toggleButton || !this.modalContent) return;

    this.isLegacy = false;
    this.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.toggleButton.addEventListener('click', this.onButtonClick.bind(this));
    this.closeButton?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
  }

  isOpen() {
    if (this.isLegacy) {
      return this.detailsContainer.hasAttribute('open');
    }

    return this.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onButtonClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    if (this.isLegacy) {
      const targetDetails = event ? event.target.closest('details') : this.detailsContainer;
      targetDetails?.setAttribute('open', true);
    } else {
      this.setAttribute('open', '');
      this.toggleButton.setAttribute('aria-expanded', 'true');
    }

    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const container = this.detailsContainer || this.modalContent;
    const focusTrapElement = container.querySelector('[tabindex="-1"]') || container;
    const focusElement = container.querySelector('input:not([type="hidden"])');

    trapFocus(focusTrapElement, focusElement);
  }

  close(focusToggle = true) {
    const toggleElement = this.isLegacy ? this.summaryToggle : this.toggleButton;
    removeTrapFocus(focusToggle ? toggleElement : null);

    if (this.isLegacy) {
      this.detailsContainer.removeAttribute('open');
    } else {
      this.removeAttribute('open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
    }

    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
